const calculateSummary = (bankTransfers) => {
  const totalTransactions = bankTransfers.length
  const notMatchedCount = bankTransfers.filter(
    (transaction) => !transaction.isBankTransferMatched,
  ).length
  const unreconciledCount = bankTransfers.filter(
    (transaction) => !transaction.isBankTransferReconciled,
  ).length
  const reconciledCount = bankTransfers.filter(
    (transaction) => transaction.isBankTransferReconciled,
  ).length
  const delta0Count = bankTransfers.filter(
    (transaction) => transaction.invoice0DeltaAmount === 0,
  ).length

  return {
    totalTransactions,
    notMatchedCount,
    unreconciledCount,
    reconciledCount,
    delta0Count,
  }
}

export default calculateSummary
